var map = {
	"./24.svg": 1458,
	"./CloudGuard-Service.svg": 1459,
	"./DNS.svg": 1460,
	"./ManagedService-Service.svg": 1461,
	"./VPC-Service.svg": 1462,
	"./backup.svg": 1463,
	"./chooseOs.svg": 1464,
	"./console.svg": 1465,
	"./dashboard.svg": 1466,
	"./ddos-d.svg": 1467,
	"./ddos.svg": 1468,
	"./disaster.svg": 1469,
	"./freeSupport.svg": 1470,
	"./global.svg": 1471,
	"./hq.svg": 1472,
	"./infrustructure.svg": 1473,
	"./list-vps.f735948 1.svg": 1474,
	"./service.svg": 1475,
	"./startup.svg": 1476,
	"./traffic-vps.aa00c67 1.svg": 1477,
	"./waf-d.svg": 1478,
	"./waf-icon-active copy.svg": 1479,
	"./waf-icon-active.svg": 1480,
	"./waf-icon.svg": 1481,
	"./waf-vps.fcecd73 1.svg": 1482,
	"./waf.svg": 1483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1686;